import(/* webpackMode: "eager" */ "/app/app/[locale]/(routes)/events/workshops/[slug]/page.tsx");
